/* SYNTAX_ — badge BEST SELLER sur les cartes produits (piloté par le tag produit "best-seller") */
(function () {
  function addBadges(handles) {
    if (!handles.size) return;
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (!m || !handles.has(m[1])) return;
      var badgeZone = card.querySelector('.card__badge');
      if (!badgeZone || badgeZone.querySelector('.bs-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'badge bs-badge';
      badge.textContent = '\u2605 BEST SELLER';
      badge.setAttribute(
        'style',
        'background-color:#D6CDBF;color:#0A0A0A;border-color:#D6CDBF;'
      );
      badgeZone.appendChild(badge);
    });
  }

  function init() {
    fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var handles = new Set();
        (data.products || []).forEach(function (p) {
          var rawTags = p.tags || [];
          if (typeof rawTags === 'string') rawTags = rawTags.split(',');
          var tags = rawTags.map(function (t) { return String(t).trim(); });
          if (tags.indexOf('best-seller') !== -1) handles.add(p.handle);
        });
        addBadges(handles);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
